﻿import { IComponent, Component, Inject, Input, Output } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../../components/application"
import { IDisposable } from "../../interfaces/general";
import { TranslationService } from "../../services/TranslationService";
import { IIdentityLink } from "../../interfaces/iFqs";
import { AuthorizationService } from "../../services/authorizationService";

@Component({
    module: FIQAssist,
    selector: "filedropdownlist",
    template: `<div class="filedropdownlist ng-class:{opened:$ctrl.opened,readonly:$ctrl.readOnly}" id="{{'filedropdownlist'+$id}}" click-outside="$ctrl.opened=false">
                    <div class="selector ng-class:{selectopen:$ctrl.opened, nopointer:$ctrl.files.length == 0, selectclose:!$ctrl.opened}" ng-click="$ctrl.opened = !$ctrl.opened && $ctrl.files.length > 0">
                        <div class="selector-content">
                            <div class="icon icon-attachment" tooltip-append-to-body="true" tooltip-class="customTooltipTB" tooltip-popup-delay="500" tooltip-placement="bottom" uib-tooltip="{{'SHOW_ATTACHMENTS_TOOLTIP' | translateAvailable}}"></div>
                            <div class="listTitle">{{$ctrl._title}}</div>
                            <div>{{'ATTACHMENTS' | translate}}</div>
                        </div>
                    </div>
                    <div class="filedroplist" ng-show="$ctrl.opened">
                        <div class="filedroplistitem" ng-repeat="item in $ctrl.files">
                            <span class="label" tooltip-class="customTooltipTB" tooltip-append-to-body="true" tooltip-placement="bottom" uib-tooltip="{{$ctrl.getTooltip(item)}}" ng-click="$ctrl.fileselected(item.id)">{{item.description}}</span>
                            <span ng-if="$ctrl.authorizationService.currentRoleIn(['CUST','SD'])" class="icon icon-trash" tooltip-append-to-body="true" tooltip-class="customTooltipTB" tooltip-popup-delay="500" tooltip-placement="bottom" uib-tooltip="{{'REMOVE_ATTACHMENT_TOOLTIP' | translateAvailable}}" ng-hide="$ctrl.readOnly" ng-click="$ctrl.onfiledelete({file:item.id})"><span class="path1"></span><span class="path2"></span></span>
                        </div>
                    </div>
               </div>`
})
class FileDropdownList implements IComponent {
    @Input() public readOnly: boolean;
    private opened: boolean = false;
    private isInitialized: boolean = false;
    private _files: FileItem[];
    private _title: string;

    constructor(
        @Inject() private translationService: TranslationService,
        @Inject() private authorizationService: AuthorizationService
    ) {
    }

    @Input()
    public get files(): FileItem[] {
        return this._files;
    }

    private getTooltip(item: FileItem) {
        let pad = (n: number) => (100 + n).toString().substring(1);
        return this.translationService.Translate("ADDED_BY_{0}_ON_{1}")
            .replace("{0}", item.createdBy)
            .replace("{1}", `${item.date.getFullYear()}-${pad(item.date.getMonth() + 1)}-${pad(item.date.getDate())} ${pad(item.date.getHours())}:${pad(item.date.getMinutes())}`);
    }

    public set files(files: FileItem[]) {
        if (this.isInitialized) {
            this._files = files.sort((a, b) => b.date.getTime() - a.date.getTime());
            this._title = (files != undefined ? this._files.length.toString() : "0");
        }
    }

    public fileselected(selected: any) {
        if (this.isInitialized)
            this.onfileclicked({ file: selected });
    }

    @Output() public onfileclicked: (args: { file: IIdentityLink }) => void;
    @Output() public onfiledelete: (args: { file: IIdentityLink }) => void;

    public async $onInit() {
        this.isInitialized = true;
        if (!this._title) {
            await this.translationService.onLoaded;
            this._title = "0";
        }
    }
}
export interface FileItem {
    id: IIdentityLink;
    description: string;
    date: Date;
    createdBy: string;
}
